import { render } from "./HeroHeader.vue?vue&type=template&id=6f18679d"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__